import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=1fea68ff&scoped=true&"
import script from "./userdetail.vue?vue&type=script&lang=js&"
export * from "./userdetail.vue?vue&type=script&lang=js&"
import style0 from "./userdetail.vue?vue&type=style&index=0&id=1fea68ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea68ff",
  null
  
)

export default component.exports